module.exports = __webpack_public_path__ + "img/float-btn-fish.ce8e7c49.svg";